import { useUserStore } from "@/stores/user";
import type { RouteRecordRaw } from "vue-router";
const SettingsPage = () => import("@/pages/settings/SettingsPage.vue");
const CompanyProfilesPage = () => import("@/pages/settings/CompanyProfilesPage.vue");
const CompanyProfilePage = () => import("@/pages/settings/CompanyProfilePage.vue");
const UsersPage = () => import("@/pages/settings/UsersPage.vue");
const FleetManagementPage = () => import("@/pages/settings/FleetManagement.vue");

export const settingsRoutes: RouteRecordRaw = {
  path: "/settings/:customerId",
  name: "settingsPage",
  component: SettingsPage,
  meta: {
    authenticated: true,
    permissions: ["company_settings", "admin_user"],
  },
  props: true,
  children: [
    {
      name: "companyProfilesPage",
      path: "companies",
      component: CompanyProfilesPage,
      props: true,
      meta: {
        permissions: ["company_settings"],
      },
      children: [{ name: "companyProfilePage", path: ":payerCompanyId", component: CompanyProfilePage, props: true }],
    },
    {
      name: "usersPage",
      path: "users",
      component: UsersPage,
      meta: {
        permissions: ["admin_user"],
      },
      props: true,
    },
    {
      name: "fleetManagementPage",
      path: "fleet-management",
      component: FleetManagementPage,
      props: true,
      meta: {
        authenticated: true,
        title: "Fleet Management",
        permissions: ["fleet_management"],
      },
    },
  ],
  beforeEnter: (to, from, next) => {
    const userStore = useUserStore();
    if (to.name === "fleetManagementPage" && !userStore.permissions.includes("fleet_management")) {
      return next(userStore.landingPage);
    }
    next();
  },
};
